var map = {
	"./article.js": 7494,
	"./articles.js": 6042,
	"./contact.js": 9836,
	"./default.js": 5997,
	"./digitalsolutions.js": 8249,
	"./event.js": 8160,
	"./home.js": 4701,
	"./people.js": 541,
	"./sector.js": 2736,
	"./shop.js": 885,
	"./women.js": 5902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3834;